/**
 * `sx` for the primary submit button on every screen inside this layout. MUI's default disabled
 * colours (black at 12%/26%) vanish on the dark panel, so a disabled button looked absent.
 */
export const authSubmitButtonSx = {
    mt: 1,
    py: 1,
    '&.Mui-disabled': {
        bgcolor: 'rgba(255, 255, 255, 0.2)',
        color: 'rgba(255, 255, 255, 0.6)'
    }
};
